import { render, staticRenderFns } from "./collapse-card.vue?vue&type=template&id=0f6c1055&scoped=true"
import script from "./collapse-card.vue?vue&type=script&lang=js"
export * from "./collapse-card.vue?vue&type=script&lang=js"
import style0 from "./collapse-card.vue?vue&type=style&index=0&id=0f6c1055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6c1055",
  null
  
)

export default component.exports